import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getVendor (params) {
    return request.get(API.EMPLOYEE_PROFILE_VENDOR, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/employee/vendor.js